/** Ein Eintrag der flachen Navigationsliste — hier zählt nur Art und Kennung. */
interface NavEntry {
  type: string
  id: string
}

/**
 * **Die nächste Aufgabe hinter denen, die gleich die Liste verlassen.**
 *
 * Gebraucht von „Ruhen lassen" in den **Aufgaben-Details**: Die Aufgabe
 * verschwindet aus der Liste, die Details gehen aber nicht zu — sie zeigen die
 * nächste (CONTEXT.md, „Ruhen lassen springt weiter"). Gesucht wird VOR dem
 * Schreiben, auf der noch vollständigen Liste; danach fehlen die Zeilen, und
 * jeder Index zeigte auf etwas anderes.
 *
 * - Hinter der LETZTEN der gehenden — bei Mehrfachauswahl gehen mehrere zugleich.
 * - Abschnittsköpfe übersprungen, wie die Pfeile im Kopf der Details (ADR 0022).
 * - Kein Rückwärts-Ersatz: Kommt keine mehr, greift der Leerzustand der Details.
 *
 * @returns die Kennung der nächsten Aufgabe oder `null`.
 */
export function nextTaskAfterLeaving(
  list: readonly NavEntry[],
  leaving: ReadonlySet<string>,
): string | null {
  let last = -1
  list.forEach((entry, index) => {
    if (entry.type === 'task' && leaving.has(entry.id)) last = index
  })
  if (last === -1) return null

  for (let index = last + 1; index < list.length; index++) {
    const entry = list[index]
    if (entry.type === 'task' && !leaving.has(entry.id)) return entry.id
  }
  return null
}
